import { FC, createElement } from 'react';
import { SiteMapItem, SiteMapProps, SiteMap } from './site-map';

export const SiteMapContainer: FC = () => {
  const items: SiteMapItem[] = [
    { label: 'Início', link: '/' },
    { label: 'Serviços', link: '/app/catalog/carta-de-servicos' },
    { label: 'Notícias', link: '/app/catalog/noticias' },
    { label: 'Governo', link: '/app/catalog/secretarias-e-orgaos' },
    { label: 'Termo de privacidade', link: '/politicas-de-privacidade' },
    {
      label: 'Painel do cidadão',
      link: '/app/painel-cidadao',
      children: [
        { label: 'Início', link: '/app/painel-cidadao' },
        {
          label: 'Minhas Solicitações',
          link: '/app/painel-cidadao/appointments-attendances',
        },
        { label: 'Notificações', link: '/app/painel-cidadao/notificacoes' },
        { label: 'Perfil', link: '/app/painel-cidadao/meus-dados' },
      ],
    },
  ];

  const props: SiteMapProps = {
    items,
  };

  return createElement(SiteMap, props);
};
